import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import useRouter from '../hook/useRouter';
import { RootState, useAppDispatch } from '../store';
import { setIsFilterOpen } from '../store/priceSlice';

export const FilterWrapTempl = ({ children, refreshObj }: { children: ReactNode; refreshObj: { [key: string]: string } }) => {
    const dispatch = useAppDispatch();
    const l10n = useSelector((state: RootState) => state.main.l10n);
    const isFilterOpen = useSelector((state: RootState) => state.price.isFilterOpen);
    const { changeParam } = useRouter([]);

    return (
        <div className={`gameinfo-filter-wrapper ${isFilterOpen ? 'is-active' : ''}`}>
            <div className="gameinfo-filter">
                <div className="gameinfo-filter__title">
                    <h2>{l10n['common.searchconditions']}</h2>
                    <button className="btn-refresh" data-areas="시세_조건검색_초기화_클릭" onClick={() => changeParam(refreshObj)}>
                        refresh
                    </button>
                </div>
                <div className="gameinfo-filter__section">
                    <div className="gameinfo-filter__list">{children}</div>
                </div>
                <div className="gameinfo-filter__footer">
                    <button className="btn-close" onClick={() => dispatch(setIsFilterOpen(false))}>
                        {l10n['common.saveandclose']}
                    </button>
                </div>
            </div>
        </div>
    );
};
